"use strict";

import Page from "./Reports.jsx";

export const auth = true;
export const title = "i18n:reports.pageTitle";
export const Component = Page;
